// Vendor-agnostic analytics abstraction. Defaults to a console sink; swap in a
// real sink (Segment, GA, Application Insights, etc.) via `setAnalyticsSink`.

import { setClaritySessionId } from "./clarity";

export type AnalyticsEvent =
  | "intake_started"
  | "question_viewed"
  | "question_answered"
  | "file_uploaded"
  | "intake_submitted"
  | "checkout_started"
  | "payment_success_returned"
  | "payment_cancelled_returned";

export type AnalyticsProps = Record<string, unknown>;

export interface AnalyticsSink {
  track(event: AnalyticsEvent, props?: AnalyticsProps): void;
}

const consoleSink: AnalyticsSink = {
  track(event, props) {
    // eslint-disable-next-line no-console
    console.debug(`[analytics] ${event}`, props ?? {});
  },
};

let sink: AnalyticsSink = consoleSink;

/** Base properties merged into every event (offer/campaign/source/env...). */
let baseProps: AnalyticsProps = {};

export function setAnalyticsSink(next: AnalyticsSink): void {
  sink = next;
}

export function setAnalyticsContext(props: AnalyticsProps): void {
  baseProps = { ...baseProps, ...props };
}

export function track(event: AnalyticsEvent, props?: AnalyticsProps): void {
  const merged = { ...baseProps, ...props };
  const reportId = merged.reportId;
  if (typeof reportId === "string" && reportId) {
    setClaritySessionId(reportId);
  }
  sink.track(event, merged);
}

/**
 * Bind Clarity (and future sinks) to an intake session when no track event fires yet.
 * Safe to call on every SPA page view once reportId is known.
 */
export function setSessionId(sessionId: string): void {
  setClaritySessionId(sessionId);
}
